import type { EnTranslation } from './en';

/** Bahasa Melayu — same shape as `en`. */
export const ms: EnTranslation = {
  header: {
    brandAlt: 'Avatar',
    title: 'Sembang dengan {{name}}',
    subtitle: 'Tanya, teroka, atau dapatkan bantuan serta-merta',
    reset: 'Set semula perbualan',
  },
  chat: {
    typing: 'Avatar sedang menaip…',
    errorFallback:
      'Maaf tentang ini. Saya tidak dapat membantu permintaan anda buat masa ini kerana isu sementara di pihak kami. Sila cuba lagi sebentar lagi.',
    networkError:
      'Ralat rangkaian. Sila semak sambungan anda dan cuba lagi.',
    widgetDisabled:
      'Sembang ini tidak lagi tersedia. Mesej baharu tidak dapat dihantar buat masa ini.',
    originNotAllowlisted:
      "Laman ini tidak dibenarkan untuk avatar ini. Minta admin tambah '{{origin}}'.",
    identifyDisabled: 'Pengesahan identiti dinyahaktifkan untuk avatar ini.',
    retry: 'Cuba lagi',
    streamingPlaceholder: '…',
    newConversationStarted: 'Perbualan baru dimulakan',
    yesterday: 'Semalam',
  },
  input: {
    placeholder: 'Tanya apa sahaja...',
    ariaLabel: 'Mesej Avatar',
    send: 'Hantar mesej',
    poweredBy: 'Dikuasakan oleh Avatar.inc',
  },
  popular: {
    ariaLabel: 'Soalan dicadangkan',
  },
  doc: {
    title: 'Widget Avatar',
  },
};
